<template>
    <v-expansion-panels accordion flat>
        <v-expansion-panel>
            <v-expansion-panel-header v-slot="{open}" class="pa-0">
                <v-row no-gutters>
                    <v-col class="v-label theme--light mb-2">
                        <label :class="{'primary--text' : open}">{{label}}</label>
                    </v-col>
                </v-row>
            </v-expansion-panel-header>
            <v-expansion-panel-content>
                <v-row no-gutters>
                    <v-col cols=2 offset=5>
                        <v-text-field :label="$translate('Top')" type="number" color="zoezi-edit-color" v-model="top" @input="setValue" :min="min" />
                    </v-col>
                    <v-col cols=1 offset=4>
                        <v-btn icon color="primary" @click.prevent="clear"><v-icon >mdi-close</v-icon></v-btn>
                    </v-col>
                </v-row>
                <v-row no-gutters>
                    <v-col cols=2>
                        <v-text-field :label="$translate('Left')" type="number" color="zoezi-edit-color" v-model="left" @input="setValue" :min="min" />
                    </v-col>

                    <v-col cols=8>
                        <v-slider v-model="all" min="0" max="100" @input="setAll()" @change="setAll()" />
                    </v-col>

                    <v-col cols=2>
                        <v-text-field :label="$translate('Right')" type="number" color="zoezi-edit-color" v-model="right" @input="setValue" :min="min"/>
                    </v-col>
                </v-row>
                <v-row no-gutters>
                    <v-col cols=2 offset=5>
                        <v-text-field :label="$translate('Bottom')" type="number" color="zoezi-edit-color" v-model="bottom" @input="setValue" :min="min" />
                    </v-col>
                </v-row>
            </v-expansion-panel-content>
        </v-expansion-panel>
    </v-expansion-panels>
</template>

<script>
export default {
    name: 'MarginPaddingSetting',

    props: ['value', 'label', 'min'],
    data: () => ({
        all: null,
        left: null,
        right: null,
        bottom: null,
        top: null
    }),
    methods: {
        setValue() {
            this.$emit('input', {top: this.top, left: this.left, bottom: this.bottom, right: this.right});
        },
        setAll() {
            if (this.all != 0) {
                this.changeAll();
            }
        },
        changeAll() {
            this.top = this.bottom = this.left = this.right = this.all;
            this.setValue();
        },
        clear() {
            this.all = undefined;
            this.changeAll();
        }
    },
    created() {
        this.left = this.value.left;
        this.right = this.value.right;
        this.bottom = this.value.bottom;
        this.top = this.value.top;
        if (this.left == this.right && this.left == this.bottom && this.left == this.top && this.left !== undefined) {
            this.all = this.left;
        }
    }
}
</script>
